<template>
  <div>

    <Row class="search-con">
      <Col>
        <Button @click="backHistory" class="search-btn">返回</Button>
        <Button @click="showAddUserFace" type="primary" style="margin-left: 20px;">添加</Button>
      </Col>
    </Row>
    <Card>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="showAddUserFaceModal"
      title="添加人脸"
      footer-hide
      >
      <Forms :resetFlag="resetFlag"
        ref="addUserFace"  
       @on-ok="addUserFaceEmit" @on-cancel="cancel" />
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="showEditUserFaceModal"
      title="编辑人脸"
      footer-hide
      >
      <Forms :resetFlag="resetFlag"
        ref="editUserFace"  
       @on-ok="editUserFaceEmit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./add_user_face_library_form.vue";

import { getUserFaceLibrary, deleteUserFaceLibrary, addUserFaceLibrary, editUserFaceLibrary} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      letterDetailFlag: false,
      tableLoading: true,
      allMoney: 0.0,
      classify_id:'',
      startTime: "",
      endTime: "",
      details:[],
      dy_id:'',
      id:'',
      resetFlag: false,
      showAddUserFaceModal:false,
      showEditUserFaceModal:false,
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "名称" , key: "face_name", editable: true },
        { title: "主页链接" , key: "",  editable: true,
          render: (h, params) => {
              // 设置为<a>标签
                return h("div", [
                  h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.download(params.row.face_path);
                        },
                      },
                    },
                    "下载"
                  )
            ])
              }},        {
          title: "Handle",
          key: "handle",
          render: (h, params) => {
            return h("div", [
            h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.handEdit(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              )
            ]);
          },
        }
      ],
      tableData: [],
    };
  },
  methods: {
    download(url){
      window.open(url, '_blank');
    },
    backHistory() {
      this.$router.go(-1);
    },
    handEdit(params){
      this.showEditUserFaceModal = true;
      this.$refs.editUserFace.setEditData(params);
    },
    showAddUserFace() {
      this.showAddUserFaceModal = true;
      this.resetFlag = !this.resetFlag;
    },editUserFaceEmit(formValidate){
      let data = {
        face_path:formValidate.face_path,
        face_name:formValidate.face_name
      }
      editUserFaceLibrary(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.showEditUserFaceModal = false
            this.$Message.success("成功!");
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    },addUserFaceEmit(formValidate){
      let data = {
        face_path:formValidate.face_path,
        face_name:formValidate.face_name,
        dy_user_id:this.id
      }
      addUserFaceLibrary(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.showAddUserFaceModal = false
            this.$Message.success("成功!");
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    },
    handleDelete(params) {
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              deleteUserFaceLibrary(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.handleSearch()
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        dy_user_id: this.id
      };
      getUserFaceLibrary(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data;
        }
        this.setTableLoading(false);
      });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.id = this.$route.query.id
    this.handleSearch()
  },
};
</script>
